export const TRACKING_ERROR_ACTION = 'displayed';
export const TRACKING_CAPTCHA_SHOWN = 'availability-captcha-shown';

export enum TRACKING_FIBER_AVAILABILITY {
    VODAFONE_PRESALES = 'vodafone-presales',
    VODAFONE_HOMEPASSED = 'vodafone-homepassed',
    VODAFONE_CONNECTED = 'vodafone-connected',
    OXG_PRESALES = 'oxg-presales',
    OXG_HOMEPASSED = 'oxg-homepassed',
    OXG_CONNECTED = 'oxg-connected',
    TELEKOM_PRESALES = 'telekom-presales',
    TELEKOM_HOMEPASSED = 'telekom-homepassed',
    TELEKOM_CONNECTED = 'telekom-connected',
    DEUTSCHE_GLASFASER_PRESALES = 'deutsche glasfaser-presales',
    DEUTSCHE_GLASFASER_HOMEPASSED = 'deutsche glasfaser-homepassed',
    DEUTSCHE_GLASFASER_CONNECTED = 'deutsche glasfaser-connected',
};
